import { render, staticRenderFns } from "./metrics-component.vue?vue&type=template&id=72ebb82a&scoped=true"
import script from "./metrics-component.ts?vue&type=script&lang=ts&external"
export * from "./metrics-component.ts?vue&type=script&lang=ts&external"
import style0 from "./metrics-component.scss?vue&type=style&index=0&id=72ebb82a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ebb82a",
  null
  
)

export default component.exports